import React from 'react';
import { FormattedMessage } from 'react-intl';

const TableNavbar = ({ products }) => {
    return (
        <div className="re_text">
            <p className='mb-0 ct-para'>{products?.products?.total} <FormattedMessage id="total_value.diamonds" defaultMessage="Diamonds" /> | <FormattedMessage id="total_value.showing" defaultMessage="total_value showing" /> {products?.products?.from} - {products?.products?.to} <FormattedMessage id="total_value.results_total_carats" defaultMessage="results Total Carats" /> {products?.product_overall?.total_carat} | <FormattedMessage id="total_value.total_value" defaultMessage="Total Value" /> ${products?.product_overall?.total_value} <FormattedMessage id="total_value.average_ct" defaultMessage="Average $/ct" /> ${products?.product_overall?.total_average_price} <FormattedMessage id="total_value.average_discount" defaultMessage="Average Discount" /> {products?.product_overall?.total_average_discount}%</p>
        </div>
    );
}
export default TableNavbar
